import styles from './ToolSaveBar.module.css';

export type ToolSaveState = 'saved' | 'dirty' | 'saving' | 'error';

interface ToolSaveBarProps {
  state: ToolSaveState;
  isNew: boolean;
  saveDisabled: boolean;
  discardDisabled: boolean;
  error?: string | null;
  onSave: () => void;
  onDiscard: () => void;
}

const SAVE_STATE_LABELS = {
  saved: 'Saved',
  dirty: 'Unsaved changes',
  saving: 'Saving…',
  error: 'Couldn’t save changes',
} as const satisfies Record<ToolSaveState, string>;

const CREATE_BUTTON_LABEL = 'Create tool';
const DISCARD_BUTTON_LABEL = 'Discard';
const SAVE_BUTTON_LABEL = 'Save changes';
const SAVING_BUTTON_LABEL = SAVE_STATE_LABELS.saving;
const INVALID_FORM_TITLE = 'Fix form errors before saving';
const SAVE_STATUS_LABEL = 'Tool save status';
const SAVE_ACTIONS_LABEL = 'Save actions';

export const ToolSaveBar = ({
  state,
  isNew,
  saveDisabled,
  discardDisabled,
  error,
  onSave,
  onDiscard,
}: ToolSaveBarProps) => {
  let saveButtonLabel = isNew ? CREATE_BUTTON_LABEL : SAVE_BUTTON_LABEL;
  if (state === 'saving') saveButtonLabel = SAVING_BUTTON_LABEL;
  const formErrorBlocksSave = saveDisabled && (state === 'dirty' || state === 'error');
  const saveDisabledTitle = formErrorBlocksSave ? INVALID_FORM_TITLE : undefined;

  return (
    <section className={styles.saveBar} data-state={state} aria-label={SAVE_STATUS_LABEL}>
      <output>
        <strong>{SAVE_STATE_LABELS[state]}</strong>
        {state === 'error' && error && <span>{error}</span>}
      </output>
      <div role="group" aria-label={SAVE_ACTIONS_LABEL}>
        <button
          type="button"
          className={styles.discardButton}
          onClick={onDiscard}
          disabled={discardDisabled}>
          {DISCARD_BUTTON_LABEL}
        </button>
        <button
          type="button"
          className={styles.saveButton}
          onClick={onSave}
          disabled={saveDisabled}
          title={saveDisabledTitle}>
          {saveButtonLabel}
        </button>
      </div>
    </section>
  );
};
